// extracted by mini-css-extract-plugin
module.exports = {"ToastMessageSupport":"Message_ToastMessageSupport__3Nzyy","fadein":"Message_fadein__1huP7","fadeout":"Message_fadeout__3rueV"};